import { render, staticRenderFns } from "./ChannelNav.vue?vue&type=template&id=3cd3f400&scoped=true&"
import script from "./ChannelNav.vue?vue&type=script&lang=js&"
export * from "./ChannelNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd3f400",
  null
  
)

export default component.exports